import React from 'react'
import PropTypes from 'prop-types'
import FlipMove from 'react-flip-move'

export default class ListAnimation extends React.Component {
  render() {
    return (
      <FlipMove
        enterAnimation={{
          from: {
            transform: 'scale(0.5,0.5)',
            opacity: 0,
          },
          to: {
            transform: 'scale(1,1)',
            opacity: 1,
          },
        }}
        leaveAnimation={{
          from: {
            transform: 'translate3d(0,0,0)',
          },
          to: {
            transform: 'translate3d(-150%,0,0)',
          },
        }}
        duration={300}
        staggerDelayBy={0}
      >
        {this.props.children}
      </FlipMove>
    )
  }
}

ListAnimation.propTypes = {
  children: PropTypes.node,
}
